// A page in place of the panes (Desktop, Files, Settings, the machine), under the workspace's bar (which names it). It
// never splits, and the row's group stays behind it as it was; picking a row goes back to the panes. Esc doesn't
// close it.

import { PAGE } from './openLinkStore';
import { DesktopPane } from './Pane';
import { PaneToasts } from './PaneToasts';
import type { Page } from './tabs';
import { FilesView } from './views/Files';
import { MachineView } from './views/Machine';
import { SettingsView } from './views/Settings';

export function PageView({ page }: { page: Page }) {
  return (
    <main className="ws-page" data-testid="page" data-page={page}>
      <section className="pane ws-pane" data-testid="pane" data-kind={page}>
        {page === 'desktop' ? <DesktopPane /> : page === 'files' ? <FilesView /> : page === 'settings' ? <SettingsView /> : <MachineView />}
        {/* links from sessions while no pane is in front (openLinkStore PAGE) */}
        <PaneToasts sid={PAGE} />
      </section>
    </main>
  );
}
